import { Calendar, Clock, Gift, Mail, Phone, Shield, User, UserCircle } from 'lucide-react';
import { formatDateTime } from 'utils/dateFormatter';
import { getStatusColor, getVerificationStatus } from '../utils';

const OverviewTab = ({ customer }) => {
  return (
    <>
      {/* Personal Information */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <User className='mr-2' size={20} />
          Personal Information
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
          <div>
            <label className='text-xs text-muted-foreground'>Phone Number</label>
            <div className='flex items-center gap-2 mt-1'>
              <Phone size={16} className='text-muted-foreground' />
              <p className='text-sm font-medium'>
                {customer?.countryCode} {customer?.phoneNumber}
              </p>
              {getVerificationStatus(customer?.phoneVerified)}
            </div>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Email</label>
            <div className='flex items-center gap-2 mt-1'>
              <Mail size={16} className='text-muted-foreground' />
              <p className='text-sm font-medium'>{customer?.email || 'N/A'}</p>
              {customer?.email && getVerificationStatus(customer?.emailVerified)}
            </div>
          </div>
          {/* <div>
            <label className='text-xs text-muted-foreground'>Gender</label>
            <p className='text-sm font-medium mt-1 capitalize'>{customer?.gender || 'N/A'}</p>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Date of Birth</label>
            <p className='text-sm font-medium mt-1'>
              {customer?.dateOfBirth ? new Date(customer.dateOfBirth).toLocaleDateString() : 'N/A'}
            </p>
          </div> */}
          <div>
            <label className='text-xs text-muted-foreground'>Joined</label>
            <div className='flex items-center mt-1'>
              <Calendar size={16} className='mr-2 text-muted-foreground' />
              <p className='text-sm font-medium'>{formatDateTime(customer?.createdAt)}</p>
            </div>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Last Login</label>
            <div className='flex items-center mt-1'>
              <Clock size={16} className='mr-2 text-muted-foreground' />
              <p className='text-sm font-medium'>{customer?.lastLogin ? formatDateTime(customer.lastLogin) : 'N/A'}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Account Status */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <Shield className='mr-2' size={20} />
          Account Status
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
          <div>
            <label className='text-xs text-muted-foreground'>Status</label>
            <p className='mt-1'>
              <span
                className={`px-3 py-1 text-xs font-medium rounded-full capitalize ${getStatusColor(customer?.status)}`}
              >
                {customer?.status?.replace('_', ' ')}
              </span>
            </p>
          </div>
          {customer?.status === 'suspended' && customer?.suspensionReason && (
            <>
              <div>
                <label className='text-xs text-muted-foreground'>Suspension Reason</label>
                <p className='text-sm font-medium mt-1'>{customer.suspensionReason}</p>
              </div>
              <div>
                <label className='text-xs text-muted-foreground'>Suspended At</label>
                <p className='text-sm font-medium mt-1'>
                  {customer?.suspendedAt ? formatDateTime(customer.suspendedAt) : 'N/A'}
                </p>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Preferences */}
      {/* {customer?.preferences && (
        <div className='bg-card border border-border rounded-lg p-6'>
          <h2 className='text-lg font-semibold mb-4 flex items-center'>
            <UserCircle className='mr-2' size={20} />
            Preferences
          </h2>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <div>
              <label className='text-xs text-muted-foreground'>Language</label>
              <p className='text-sm font-medium mt-1 capitalize'>{customer.preferences.language || 'English'}</p>
            </div>
            <div>
              <label className='text-xs text-muted-foreground'>Notifications</label>
              <div className='flex gap-2 mt-1'>
                {customer.preferences.notifications?.push && (
                  <span className='px-2 py-1 text-xs bg-green-500/10 text-green-600 rounded-full'>Push</span>
                )}
                {customer.preferences.notifications?.email && (
                  <span className='px-2 py-1 text-xs bg-green-500/10 text-green-600 rounded-full'>Email</span>
                )}
                {customer.preferences.notifications?.sms && (
                  <span className='px-2 py-1 text-xs bg-green-500/10 text-green-600 rounded-full'>SMS</span>
                )}
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/* Loyalty Points */}
      {/* <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <Gift className='mr-2' size={20} />
          Loyalty & Rewards
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
          <div>
            <label className='text-xs text-muted-foreground'>Loyalty Points</label>
            <p className='text-2xl font-bold text-primary mt-1'>{customer?.loyaltyPoints || 0}</p>
          </div>
        </div>
      </div> */}

      {/* Emergency Contacts */}
      {customer?.emergencyContacts && customer.emergencyContacts.length > 0 && (
        <div className='bg-card border border-border rounded-lg p-6'>
          <h2 className='text-lg font-semibold mb-4'>Emergency Contacts</h2>
          <div className='space-y-4'>
            {customer.emergencyContacts.map((contact, index) => (
              <div key={index} className='border border-border rounded-lg p-4'>
                <div className='flex items-center justify-between'>
                  <div>
                    <p className='font-medium'>{contact.name}</p>
                    <p className='text-sm text-muted-foreground'>
                      {contact.countryCode} {contact.phoneNumber}
                    </p>
                    {contact.relationship && (
                      <p className='text-xs text-muted-foreground mt-1'>Relationship: {contact.relationship}</p>
                    )}
                  </div>
                  {contact.isPrimary && (
                    <span className='px-2 py-1 text-xs bg-primary/10 text-primary rounded-full'>Primary</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Social Accounts */}
      {customer?.socialAccounts && customer.socialAccounts.length > 0 && (
        <div className='bg-card border border-border rounded-lg p-6'>
          <h2 className='text-lg font-semibold mb-4'>Social Accounts</h2>
          <div className='flex flex-wrap gap-2'>
            {customer.socialAccounts.map((social, index) => (
              <span key={index} className='px-3 py-1 text-xs font-medium rounded-full bg-primary/10 text-primary capitalize'>
                {social.provider}
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default OverviewTab;
